import { Participant } from "twilio-video";
import React, { useEffect, useState } from "react";

const Participants = ({ room }) => {
  const [participants, setParticipants] = useState<Participant[]>([]);

  useEffect(() => {
    const participantConnected = (participant: Participant) => {
      if (participant.state === "connected") {
        setParticipants((prev) => {
          const pxx = [...prev];
          if (!prev.length || !prev?.find((p) => p.sid === participant.sid)) {
            pxx.push(participant);
          }
          return pxx;
        });
      }

      // participant.on("reconnecting", (leavingParticipant) => {
      //   setParticipants((prevParticipants) => {
      //     const newParticipants = prevParticipants.map((p) => {
      //       if (p.sid === leavingParticipant.sid) {
      //         return leavingParticipant;
      //       }
      //       return p;
      //     });
      //     return newParticipants;
      //   });
      // });

      participant.on("disconnected", (leavingParticipant) => {
        setParticipants((prevParticipants) => {
          const newParticipants = prevParticipants.map((p) => {
            if (p.sid === leavingParticipant.sid) {
              return leavingParticipant;
            }
            return p;
          });
          return newParticipants;
        });
      });
    };

    if (room) {
      room.participants.forEach(participantConnected);
      room.on("participantConnected", participantConnected);
      room.on("disconnected", () => {
        setParticipants([]);
      });
    }
  }, [room]);

  const numberOfParticipants = participants?.filter((p) => p.state === "connected")?.length;

  if (!numberOfParticipants) {
    return;
  }

  return (
    <>
      <p className="participants">Participants {`(${numberOfParticipants})`}</p>
      {/* <table>
        <thead>
          <tr>
            <th>Id</th>
            <th>Name</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {participants?.map((p) => {
            const identifierObj = p?.identity && JSON.parse(p?.identity);
            return (
              <tr key={p?.sid}>
                <td className="id">{p?.sid.slice(0, 5)}</td>
                <td className="name">
                  {identifierObj?.name ?? identifierObj?.browserName}
                </td>
                <td className="name">{p?.state}</td>
              </tr>
            );
          })}
        </tbody>
      </table> */}
    </>
  );
};

export default Participants;
